import {lowerFirst} from 'lodash';
import { action, observable } from "mobx";
import {ListTableStore} from "./ListTableStore";
import {api} from "../api";
 

export class CrudPageStore {
    modelName: string;
    @observable formClass: any;
    @observable listClass: any;
    @observable api: any;
    @observable isFormModalOpen = false;
    @observable selectedId: number|null = null;
    @observable listTableStore: ListTableStore;

    constructor(modelName: string) {
        this.modelName = modelName;

        Promise.resolve(import('../components/pages/' + this.modelName + 'Page')).then(this.load);
    }

    @action
    load = (module: any) => {
        this.formClass = module[this.modelName + 'Form'];
        this.listClass = module[this.modelName + 'List'];
        const filterFormClass = module[this.modelName + 'FilterForm'];

        this.api = api[lowerFirst(this.modelName)];

        this.listTableStore = new ListTableStore(
            this.api.getListAction,
            1,
            new filterFormClass()
        );
    };

    @action
    openFormModal = (id: number|null = null) => {
        this.selectedId = id;
        this.isFormModalOpen = true;
    };

    @action
    closeFormModal = (refresh = false) => {
        this.selectedId = null;
        this.isFormModalOpen = false;

        if (refresh) {
            this.listTableStore.refresh();
        }
    };

    @action
    delete = (id: number) => {
        if (confirm('Are you sure, you want to delete this record?')) {
            this.api.postDeleteAction(id).then(() => {
                 this.listTableStore.refresh();
            });
        }
    };
}



// WEBPACK FOOTER //
// ./resources/js/stores/CrudPageStore.ts